import * as React from 'react';

import { IPage, IPlaceHolder, IDocument, IDragInfo } from '../../../../../../../infrastructure/interfaces';
import PageEditor from '../../../common/PageEditor';

export interface IPageLayoutProps {
  page: IPage;
  handleDrop(index: number, data: IPlaceHolder, dragInfo: IDragInfo): void;
  removeProduct(data: any, index: number): void;
  document: IDocument | null;
}

export default class PageLayout extends React.Component<IPageLayoutProps> {
  constructor(props: IPageLayoutProps) {
    super(props);
  }


  render() {
    return (this.props.page.placeholders.map((p, i) => {
      return (
        <PageEditor
          accepts={p.accepts}
          lastDroppedItem={p}
          onDrop={(data: any, type: any) => this.props.handleDrop(i, data, type)}
          removeProduct={this.props.removeProduct}
          index={i}
          key={i}
          page={this.props.page}
          document={this.props.document}
          layout="Poster"
        />);
    }));
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/Postcard/Components/PageLayout/PageLayout.tsx